import { getCookieByName } from '../utils/functions';
import { useSelector } from 'react-redux';

const useDelegatingLearnMore = () => {
  const delegatingLearnMoreCookie = getCookieByName(
    'delegatingLearnMore',
    true
  );

  const delegatingLearnMoreConfig = useSelector(
    (state: any) => state.workflow.flowDefiningAttributes?.delegatingLearnMore
  );

  if (
    delegatingLearnMoreCookie !== null &&
    delegatingLearnMoreCookie !== undefined
  ) {
    return delegatingLearnMoreCookie;
  }
  if (
    delegatingLearnMoreConfig !== null &&
    delegatingLearnMoreConfig !== undefined
  ) {
    return delegatingLearnMoreConfig;
  }
  return false;
};

export default useDelegatingLearnMore;
